import useSWR, { SWRResponse } from "swr";
import type { Segment } from "@memento/types/segment";
import { getLoadingStatus, useUnauthenticatedFetcher } from "src/libs/fetcher";
import { getPublicSegmentsEndpointUrl } from "src/libs/api-endpoint-lib";

export type PublicSegmentsResponse = {
  segments: Segment[];
  totalSubmitted: number;
};

export const useCardPublicSegments = (
  cardUrl: string | null,
  cardId: string | null,
  // when the caller already has this data from an SSR fetch, pass it here so
  // we can skip the redundant client-side fetch on mount -- it'll still
  // revalidate as usual on focus/reconnect
  fallbackData?: PublicSegmentsResponse
) => {
  const fetcher = useUnauthenticatedFetcher();
  const key =
    cardUrl && cardId ? getPublicSegmentsEndpointUrl(cardUrl, cardId) : null;

  const { data, error, mutate }: SWRResponse<PublicSegmentsResponse, Error> =
    useSWR(key, (url: string) => fetcher(url), {
      fallbackData,
      revalidateOnMount: fallbackData ? false : undefined,
    });

  return {
    segments: data?.segments ?? null,
    totalSubmitted: data?.totalSubmitted ?? 0,
    error,
    status: getLoadingStatus(key, data, error),
    mutate,
  };
};
